export function setHistoryState(
    params: URLSearchParams,
    style: 'push' | 'replace' = 'push'
) {
    if (window.location.search !== '?' + params.toString()) {
        const newSearchParams =
            window.location.pathname + '?' + params.toString();
        if (style === 'push') {
            window.history.pushState(
                { path: newSearchParams },
                '',
                newSearchParams
            );
        } else {
            window.history.replaceState(
                { path: newSearchParams },
                '',
                newSearchParams
            );
        }
    }
}
